<template>
  <TableEntityMgr />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
